import { Routes, Route, Router } from 'react-router-dom';
import './App.css';
import '@fontsource/lato/400.css';
import '@fontsource/lato/300.css';
import '@fontsource/oxanium/400.css';
import '@fontsource/oxanium/300.css';
import { Home } from './pages/home';
import { AboutUs } from './pages/about-us';
import { ContactUs } from './pages/contact-us';
import 'leaflet/dist/leaflet.css';
import Login from './pages/login';
import { TermsAnsConditions } from './pages/terms-and-conditions';
import { PrivacyPolicy } from './pages/privacy-policy';


function App() {
  return (
      
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/terms-conditions" element={<TermsAnsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="*" element={<div className="p-4">404 Page Not Found</div>} />
      </Routes>
  );
}

export default App;
